import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import Home from './components/Home';
import Navbar from './components/Navbar';
import PrivateRoute from './PrivateRoute';
import CoMaster from './components/CoMaster';
import UnitMaster from './components/UnitMaster';
import ItemMaster from './components/ItemMaster';
import Table from './components/Table';
import CompanyInfo from './components/CompanyInfo';
import ChangePass from './components/ChangePass';
import UserList from './components/UserList';
import QuotationRegisters from './components/QuotationRegisters';
import TaxMaster from './components/TaxMaster';
import Edit from './components/Edit';
import NewEdit from './components/NewEdit';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />



          {/* <Route path="/register" element={<Register />} /> */}

          <Route path="/Home" element={<PrivateRoute element={<Home />} />} />
          <Route path="/edit/:id" element={<PrivateRoute element={<NewEdit />} />} />
          <Route path="/CoMaster" element={<PrivateRoute element={<CoMaster />} />} />
          <Route path="/TaxMaster" element={<PrivateRoute element={<TaxMaster />} />} />

          <Route path="/UnitMaster" element={<PrivateRoute element={<UnitMaster />} />} />
          <Route path="/ItemMaster" element={<PrivateRoute element={<ItemMaster />} />} />
          <Route path="/CompanyInfo" element={<PrivateRoute element={<CompanyInfo />} />} />
          <Route path="/ChangePass" element={<PrivateRoute element={<ChangePass />} />} />
          <Route path="/UserList" element={<PrivateRoute element={<UserList />} />} />
          <Route path="/Table" element={<PrivateRoute element={<Table />} />} />
          <Route path="/QuotationRegisters" element={<PrivateRoute element={<QuotationRegisters />} />} />
          <Route path="*" element={<PrivateRoute element={<Home />} />} />
          


          {/* <Route path="/Home" element={<Home />} /> */}
          {/* <Route path="/Navbar" element={<Navbar />} /> */}
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
